import { Component, computed, input } from '@angular/core';
import type { OnyxOptional } from '../../../interfaces';
import type { ButtonActionType } from '../../../internal/interfaces';
import type { OnyxIconName } from '../../icons/interfaces';
import { OnyxIconComponent } from '../../icons/onyx-icon/onyx-icon.component';
import { OnyxSpinnerComponent } from '../../spinner/onyx-spinner/onyx-spinner.component';

@Component({
  selector: 'onyx-button',
  imports: [OnyxSpinnerComponent, OnyxIconComponent],
  templateUrl: './onyx-button.component.html',
  styleUrl: './onyx-button.component.scss',
})
export class OnyxButtonComponent {
  public readonly variant = input<
    'primary' | 'outlined' | 'ghost' | 'transparent'
  >('primary');
  public readonly color = input<
    'blue' | 'green' | 'red' | 'violet' | 'black' | 'orange'
  >('black');
  public readonly size = input<24 | 32 | 40>(40);
  public readonly spinner = input(false);
  public readonly disabled = input(false);
  public readonly actionType = input<ButtonActionType>('button');
  public readonly leftIcon = input<OnyxOptional<OnyxIconName>>();
  public readonly rightIcon = input<OnyxOptional<OnyxIconName>>();

  protected spinnerColor = computed(() => {
    if (this.variant() === 'primary') return 'white';

    switch (this.color()) {
      case 'blue':
      case 'green':
      case 'red':
      case 'violet':
      case 'orange':
        return 'blue';

      case 'black':
        return 'black';
    }
  });
  protected spinnerSize = computed(() => (this.size() === 24 ? 16 : 24));
  protected iconSize = computed(() => (this.size() === 24 ? 14 : 20));
}
